import { useState } from "react";

export function ProductGallery({ p }) {
    const images = p.images && p.images.length > 0 ? p.images : [];
    const [idx, setIdx] = useState(0);

    if (images.length === 0) {
        return (
            <div className="relative aspect-square border-2 border-[hsl(var(--ink))] bg-[hsl(var(--dust-300))]">
                <svg viewBox="0 0 400 400" className="h-full w-full p-16">
                    <g fill="none" stroke="hsl(var(--dust-50))" strokeWidth="2.5">
                        <circle cx="200" cy="200" r="160" opacity="0.2" />
                        <circle cx="200" cy="200" r="120" />
                        <circle cx="200" cy="200" r="60" opacity="0.5" />
                        <text x="200" y="208" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="14" stroke="none" fill="hsl(var(--dust-50))">
                            {p.sku}
                        </text>
                    </g>
                </svg>
                {p.badge && (
                    <span className={`absolute left-4 top-4 px-3 py-1 font-mono-brand text-xs uppercase tracking-wider ${p.badge === "SALE" ? "bg-[hsl(var(--rust))] text-[hsl(var(--dust-50))]" : "bg-[hsl(var(--ink))] text-[hsl(var(--primary))]"}`}>
                        {p.badge}
                    </span>
                )}
            </div>
        );
    }

    return (
        <div>
            <div className="relative aspect-square border-2 border-[hsl(var(--ink))] bg-[hsl(var(--dust-50))]" data-testid="product-gallery-main">
                <img src={images[idx]} alt={p.name} className="absolute inset-0 h-full w-full object-contain p-4" />
                {p.badge && (
                    <span className={`absolute left-4 top-4 px-3 py-1 font-mono-brand text-xs uppercase tracking-wider ${p.badge === "SALE" ? "bg-[hsl(var(--rust))] text-[hsl(var(--dust-50))]" : "bg-[hsl(var(--ink))] text-[hsl(var(--primary))]"}`}>
                        {p.badge}
                    </span>
                )}
                {images.length > 1 && (
                    <>
                        <button
                            type="button"
                            aria-label="Previous"
                            onClick={() => setIdx((i) => (i - 1 + images.length) % images.length)}
                            className="absolute left-2 top-1/2 -translate-y-1/2 border border-[hsl(var(--ink))] bg-[hsl(var(--dust-50))]/95 px-3 py-2 font-display text-xl hover:bg-[hsl(var(--primary))]"
                            data-testid="gallery-prev"
                        >
                            ‹
                        </button>
                        <button
                            type="button"
                            aria-label="Next"
                            onClick={() => setIdx((i) => (i + 1) % images.length)}
                            className="absolute right-2 top-1/2 -translate-y-1/2 border border-[hsl(var(--ink))] bg-[hsl(var(--dust-50))]/95 px-3 py-2 font-display text-xl hover:bg-[hsl(var(--primary))]"
                            data-testid="gallery-next"
                        >
                            ›
                        </button>
                        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 border border-[hsl(var(--ink))] bg-[hsl(var(--dust-50))]/95 px-2 py-1 font-mono-brand text-[10px] uppercase tracking-wider">
                            {idx + 1} / {images.length}
                        </div>
                    </>
                )}
            </div>
            {images.length > 1 && (
                <div className="mt-3 flex gap-2 overflow-x-auto">
                    {images.map((src, i) => (
                        <button
                            key={src + i}
                            type="button"
                            onClick={() => setIdx(i)}
                            className={`relative h-16 w-16 shrink-0 border-2 bg-[hsl(var(--dust-50))] transition-colors ${i === idx ? "border-[hsl(var(--primary))]" : "border-[hsl(var(--dust-300))] hover:border-[hsl(var(--ink-soft))]"}`}
                            aria-label={`Show image ${i + 1}`}
                            data-testid={`gallery-thumb-${i}`}
                        >
                            <img src={src} alt="" className="absolute inset-0 h-full w-full object-contain p-1" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
